<script setup>
import { computed } from 'vue';
import ChannelSelector from '../ChannelSelector.vue';

const props = defineProps({
  channel: {
    type: Object,
    required: true,
  },
  enabledFeatures: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['channelItemClick']);

const hasFbConfigured = computed(() => window.chatwootConfig?.fbAppId);
const hasInstagramConfigured = computed(
  () => window.chatwootConfig?.instagramAppId
);
const hasTiktokConfigured = computed(() => window.chatwootConfig?.tiktokAppId);

const isActive = computed(() => {
  const { key } = props.channel;
  if (Object.keys(props.enabledFeatures).length === 0) return false;

  if (key === 'website') return props.enabledFeatures.channel_website;
  if (key === 'facebook') {
    return props.enabledFeatures.channel_facebook && hasFbConfigured.value;
  }
  if (key === 'email') return props.enabledFeatures.channel_email;
  if (key === 'instagram') {
    return (
      props.enabledFeatures.channel_instagram && hasInstagramConfigured.value
    );
  }
  if (key === 'tiktok') {
    return props.enabledFeatures.channel_tiktok && hasTiktokConfigured.value;
  }
  if (key === 'voice' || key === 'whatsapp_call') {
    return props.enabledFeatures.channel_voice;
  }

  return [
    'website',
    'twilio',
    'api',
    'whatsapp',
    'sms',
    'telegram',
    'line',
    'instagram',
    'tiktok',
    'voice',
  ].includes(key);
});

const isComingSoon = computed(
  () => ['voice'].includes(props.channel.key) && !isActive.value
);

const isBeta = computed(() =>
  ['tiktok', 'voice', 'whatsapp_call'].includes(props.channel.key)
);

const hasVoiceBadge = computed(
  () =>
    ['voice', 'whatsapp_call'].includes(props.channel.key) &&
    !!props.enabledFeatures.channel_voice
);

const onItemClick = () => {
  if (isActive.value) emit('channelItemClick', props.channel.key);
};
</script>

<template>
  <ChannelSelector
    :title="channel.title"
    :description="channel.description"
    :icon="channel.icon"
    :channel-key="channel.key"
    :badge="channel.badge"
    :highlights="channel.highlights"
    :featured="channel.featured"
    :is-coming-soon="isComingSoon"
    :is-beta="isBeta"
    :has-voice-badge="hasVoiceBadge"
    :disabled="!isActive"
    @click="onItemClick"
  />
</template>
